import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import Navbar from './Navbar';
import Footer from './Footer';

const ConsejoSabiosPage: React.FC = () => {
    const navigate = useNavigate();
    const { language } = useLanguage();
    const [hoveredImage, setHoveredImage] = React.useState<string | null>(null);
    
    const t = (es: string, en: string) => language === 'es' ? es : en;

    const handleThemeChange = (theme: number) => {
        // Navegar a la página del libro correspondiente
        const bookRoutes = {
            2: '/libros/1',
            3: '/libros/2', 
            4: '/libros/3',
            5: '/libros/4',
            6: '/libros/5',
            7: '/libros/6',
            8: '/libros/7',
            9: '/libros/8'
        };
        const route = bookRoutes[theme as keyof typeof bookRoutes];
        if (route) {
            window.location.href = route;
        }
    };

    const handleDemo = () => {
        // Aquí iría la lógica para mostrar la demo
        console.log('Demo iniciada');
        // Redirigir a demo o mostrar modal
    };

    const handleJoinCommunity = () => {
        // Aquí iría la lógica para unirse a la comunidad
        console.log('Unirse a la comunidad');
        // Redirigir a registro o comunidad
    };

    return (
        <div className="min-h-screen bg-gradient-to-br from-purple-50 via-blue-50 to-green-50">
            {/* Navbar */}
            <Navbar currentTheme={1} onThemeChange={handleThemeChange} />
            
            {/* Contenido principal */}
            <main className="pt-14 sm:pt-16">
                
                {/* 1. Sección Héroe */}
                <section className="w-full relative bg-gradient-to-br from-purple-600 via-blue-500 to-green-500 flex items-end" style={{minHeight: '0', height: 'auto'}}>
                  <img
                    src="/images/circulosabios/PortadaDebate.png"
                    alt="Portada Debate"
                    className="w-full h-auto object-cover object-center z-0"
                    style={{ maxHeight: 'none' }}
                  />
                  <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-black/30 z-10 pointer-events-none" />
                  <div className="absolute bottom-0 w-full z-20 flex justify-center">
                    <div className="mb-8 w-full max-w-3xl px-4 py-4 text-center" style={{ marginLeft: '-180px' }}>
                      <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-2 drop-shadow-lg">
                        {t('¡Bienvenido a DEBATE!', 'Welcome to DEBATE!')}
                      </h1>
                      <p className="text-2xl md:text-3xl text-white font-semibold drop-shadow">
                        {t('El primer juego de argumentos donde tus ideas son tus mejores armas', 'The first argument game where your ideas are your best weapons')}
                      </p>
                    </div>
                  </div>
                </section>

                {/* 2. Sección de Imágenes: 4 columnas verticales */}
                <section className="py-16 sm:py-20 lg:py-24 bg-gradient-to-r from-[#FCD34D] via-[#6EC1E4] to-[#A6E3A1] relative">
                    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
                            {/* Imagen 1 - MenuDebate.png */}
                            <div 
                                className="h-full flex items-center justify-center"
                                onMouseEnter={() => setHoveredImage('menu')}
                                onMouseLeave={() => setHoveredImage(null)}
                            >
                                <img
                                    src="/images/circulosabios/MenuDebate.png"
                                    alt="Menú de Debate"
                                    className="w-full h-full object-cover object-center rounded-2xl shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:scale-105"
                                />
                            </div>
                            
                            {/* Imagen 2 - LevelUp */}
                            <div 
                                className="h-full flex items-center justify-center"
                                onMouseEnter={() => setHoveredImage('levelup')}
                                onMouseLeave={() => setHoveredImage(null)}
                            >
                                <img
                                    src="/images/circulosabios/LevelUp.png"
                                    alt="Subida de Nivel"
                                    className="w-full h-full object-contain object-center rounded-2xl shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:scale-105"
                                />
                            </div>
                            
                            {/* Imagen 3 - LeaderBoard */}
                            <div 
                                className="h-full flex items-center justify-center"
                                onMouseEnter={() => setHoveredImage('leaderboard')}
                                onMouseLeave={() => setHoveredImage(null)}
                            >
                                <img
                                    src="/images/circulosabios/LeaderBoard.png"
                                    alt="Tabla de Líderes"
                                    className="w-full h-full object-cover object-center rounded-2xl shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:scale-105"
                                />
                            </div>
                            
                            {/* Imagen 4 - UserPage */}
                            <div 
                                className="h-full flex items-center justify-center"
                                onMouseEnter={() => setHoveredImage('userpage')}
                                onMouseLeave={() => setHoveredImage(null)}
                            >
                                <img
                                    src="/images/circulosabios/UserPage.png"
                                    alt="Página de Usuario"
                                    className="w-full h-full object-cover object-center rounded-2xl shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:scale-105"
                                />
                            </div>
                        </div>
                    </div>
                    
                    {/* Personaje Liebre Hero en esquina inferior derecha */}
                    <div className="absolute bottom-4 right-2 z-10">
                        <img
                            src="/images/circulosabios/LiebreHero.png"
                            alt="Liebre Hero"
                            className="w-40 h-40 sm:w-48 sm:h-48 lg:w-56 lg:h-56 object-contain drop-shadow-lg hover:scale-110 transition-all duration-300"
                        />
                        
                        {/* Globo de texto */}
                        {hoveredImage && (
                            <div className="absolute bottom-full right-0 mb-2 bg-white rounded-lg shadow-xl border border-gray-200 p-3 max-w-xs z-20 animate-bounce">
                                <div className="text-sm font-medium text-gray-800">
                                    {hoveredImage === 'menu' && t('¡Aquí puedes acceder a todas las opciones de debate!', 'Here you can access all debate options!')}
                                    {hoveredImage === 'levelup' && t('¡Sube de nivel y desbloquea nuevos argumentos!', 'Level up and unlock new arguments!')}
                                    {hoveredImage === 'leaderboard' && t('¡Compite con otros y mira quién está en la cima!', 'Compete with others and see who\'s on top!')}
                                    {hoveredImage === 'userpage' && t('¡Personaliza tu perfil y revisa tus insignias!', 'Customize your profile and review your badges!')}
                                </div>
                                {/* Flecha del globo */}
                                <div className="absolute top-full right-4 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-white"></div>
                            </div>
                        )}
                    </div>
                </section>

                {/* 4. Sección Campo de Debate - Estilo Hero */}
                <section className="w-full relative bg-gradient-to-br from-purple-600 via-blue-500 to-green-500 flex items-center justify-center">
                    <img
                        src="/images/circulosabios/CampoDebate.png"
                        alt="Campo de Debate"
                        className="w-full h-auto object-cover object-center z-0"
                    />
                    <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-black/40 z-10 pointer-events-none" />
                    <div className="absolute inset-0 z-20 flex items-start justify-center px-4 py-8" style={{ paddingTop: '80px' }}>
                        <div className="bg-black/30 backdrop-blur-sm rounded-2xl p-8 max-w-4xl text-center" style={{ marginLeft: '-160px' }}>
                            <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 drop-shadow-lg">
                                {t('¡Bienvenido al Campo del Debate!', 'Welcome to the Debate Field!')}
                            </h2>
                            <div className="text-white text-lg md:text-xl leading-relaxed mb-8 drop-shadow">
                                <p className="mb-4">{t('El escenario está listo, los argumentos esperan.', 'The stage is ready, the arguments await.')}</p>
                                <p className="mb-4">{t('Aquí no se lucha con espadas, se combate con ideas.', 'Here we don\'t fight with swords, we battle with ideas.')}</p>
                                <p>{t('Demuestra que tu persuasión es digna del Consejo de los Sabios, conquista las insignias y deja tu huella en la historia.', 'Prove that your persuasion is worthy of the Council of Sages, conquer the badges and leave your mark on history.')}</p>
                            </div>
                            <button className="px-8 py-4 bg-gradient-to-r from-purple-500 to-blue-500 text-white rounded-full text-lg font-bold hover:from-purple-600 hover:to-blue-600 transform hover:scale-105 transition-all duration-300 shadow-2xl">
                                {t('¿Te crees capaz de ser un sabio más del consejo?', 'Do you think you\'re capable of being another sage of the council?')}
                            </button>
                        </div>
                    </div>
                </section>
            </main>

            {/* Footer */}
            <Footer />
        </div>
    );
};

export default ConsejoSabiosPage; 